// @flow
import * as React from 'react'
import uuid from 'uuid/v1'
import { FormGroup } from 'ui/Form'
import Tooltip from 'ui/Tooltip'

import './FormControl.scss'

type Props = {
  label: React.Node,
  sublabel: React.Node,
  radio: boolean,
  bold: boolean,
  uppercase: boolean,
  children: React.Node,
  toolTip?: React.Node,
  required: boolean,
}

export default class FormControl extends React.Component<Props> {
  static defaultProps = {
    label: '',
    sublabel: '',
    bold: false,
    uppercase: true,
    radio: false,
    required: false,
  }

  render = () => {
    const controlId = this.firstChild.props.id || uuid()
    const control = React.cloneElement(this.firstChild, { id: controlId })

    return (
      <FormGroup>
        <div className={this.className}>
          <div className="FormControl--labelContainer">
            <label className="FormControl-label" htmlFor={controlId}>
              {this.props.label}
            </label>
            {this.renderRequiredMaybe()}
            {this.renderToolTipMaybe()}
          </div>
          <label className="FormControl-sublabel" htmlFor={controlId}>
            {this.props.sublabel}
          </label>
          <div className="FormControl-control">{control}</div>
        </div>
      </FormGroup>
    )
  }

  renderRequiredMaybe = () => {
    if (!this.props.required) return null

    return <sup className="FormControl--required">*</sup>
  }

  renderToolTipMaybe = () => {
    if (!this.props.toolTip) return null

    return (
      <div className="FormControl--toolTip">
        <Tooltip>{this.props.toolTip}</Tooltip>
      </div>
    )
  }

  get className(): string {
    return [
      'FormControl',
      this.props.bold ? 'FormControl--bold' : '',
      this.props.uppercase ? 'FormControl--uppercase' : '',
      this.props.radio ? 'FormControl--radio' : '',
    ].join(' ')
  }

  get firstChild(): any {
    const children = React.Children.toArray(this.props.children)
    return children[0]
  }
}
